import React from 'react'

const ModalHeader = ({
  selectedMedia,
  isOwner,
  editingName,
  newName,
  loading,
  onClose,
  onStartEditName,
  onSaveName,
  onCancelEdit,
  onSetNewName,
  isClearTheme
}) => (
  <div className={`flex items-center justify-between p-6 border-b ${isClearTheme ? 'border-gray-200' : 'border-white/10'}`}>
    <div className="flex-1 mr-4">
      {editingName === selectedMedia._id ? (
        <EditNameForm
          newName={newName}
          loading={loading}
          onSave={() => onSaveName(selectedMedia._id)}
          onCancel={() => onCancelEdit('name')}
          onSetNewName={onSetNewName}
          isClearTheme={isClearTheme}
        />
      ) : (
        <DisplayName
          selectedMedia={selectedMedia}
          isOwner={isOwner}
          onStartEdit={() => onStartEditName(selectedMedia)}
          isClearTheme={isClearTheme}
        />
      )}
    </div>
    <CloseButton onClick={onClose} isClearTheme={isClearTheme} />
  </div>
)

const EditNameForm = ({ newName, loading, onSave, onCancel, onSetNewName, isClearTheme }) => (
  <div className="flex items-center gap-2">
    <input
      type="text"
      value={newName}
      onChange={(e) => onSetNewName(e.target.value)}
      className={`flex-1 px-3 py-2 border rounded-lg text-lg font-semibold focus:outline-none focus:ring-2 focus:ring-purple-500 ${
        isClearTheme
          ? 'bg-gray-100 border-gray-300 text-gray-900 placeholder-gray-500'
          : 'bg-white/5 border-white/20 text-white placeholder-gray-400'
      }`}
      placeholder="Enter media name..."
    />
    <button
      onClick={onSave}
      disabled={loading}
      className="bg-green-600 hover:bg-green-700 disabled:bg-gray-600 text-white px-3 py-2 rounded-lg transition-colors"
    >
      {loading ? '...' : '✓'}
    </button>
    <button
      onClick={onCancel}
      className={`px-3 py-2 rounded-lg transition-colors ${
        isClearTheme
          ? 'bg-gray-300 hover:bg-gray-400 text-gray-900'
          : 'bg-gray-600 hover:bg-gray-700 text-white'
      }`}
    >
      ✕
    </button>
  </div>
)

const DisplayName = ({ selectedMedia, isOwner, onStartEdit, isClearTheme }) => (
  <div className="flex items-center gap-2">
    <h3 className={`text-xl font-semibold ${isClearTheme ? 'text-gray-900' : 'text-white'}`}>
      {selectedMedia.customName || selectedMedia.originalName}
    </h3>
    {isOwner && (
      <button
        onClick={onStartEdit}
        className={`transition-colors ${
          isClearTheme ? 'text-gray-600 hover:text-gray-900' : 'text-gray-400 hover:text-white'
        }`}
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
        </svg>
      </button>
    )}
  </div>
)

const CloseButton = ({ onClick, isClearTheme }) => (
  <button
    onClick={onClick}
    className={`transition-colors ${
      isClearTheme ? 'text-gray-600 hover:text-gray-900' : 'text-gray-400 hover:text-white'
    }`}
  >
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
  </button>
)

export default ModalHeader
